import { render, staticRenderFns } from "./newCustomerCar.vue?vue&type=template&id=4b6658fd&scoped=true"
import script from "./newCustomerCar.vue?vue&type=script&lang=js"
export * from "./newCustomerCar.vue?vue&type=script&lang=js"
import style0 from "./newCustomerCar.vue?vue&type=style&index=0&id=4b6658fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6658fd",
  null
  
)

export default component.exports